import React from 'react'
import moment from 'moment'
import { browserHistory } from 'react-router'

import TenantsSelect from '../../../components/Tenants/TenantsSelect.jsx'

import { tenant } from '../../../core/controllers/Tenant';
import { modal } from '../../../core/utilities/modal'

export default class SetupPaymentPlan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tenant_id: 0,
            rentAmount: 0,
            termLength: 0,
        };
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    sortTenantSelect(e) {
        var tenant_id = e.target.value;

        this.setState({
            tenant_id: tenant_id
        });
    }

    validate() {
        const tenantId = this.state.tenant_id;
        const rentAmount = this.state.rentAmount;
        const termLength = this.state.termLength;

        if(tenantId == 0) {
            modal.showInfo("Select a Tenant who you would like to setup a plan for.", "danger", "top", "center");
            return false;
        } else if(rentAmount == 0) {
            modal.showInfo("Enter the total payment plan amount.", "danger", "top", "center");
            return false;
        } else if(termLength == 0) {
            modal.showInfo("How long should this payment plan last?", "danger", "top", "center");
            return false;
        }

        return true;
    }

    startPaymentPlan(e){
        if(!this.validate()) {
            return;
        }

        const paymentData = this.state;

        tenant.createPaymentPlan(paymentData, function(response) {
            modal.showInfo("Payment plan has been setup!  The tenant has also been notified!", "success", "top", "center");
            browserHistory.replace('/tenants');
        });
    }

    buildTermsSelect() {
        var terms = [];
        for(var i = 1; i <= 36; i++) {
            terms.push(i);
        }

        return terms.map((term) => (
            <option key={'term-' + term} value={term}>{term}</option>
        ));
    }

    formatAmount(value) {
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(value)
        }

        return value;
    }

    onRentChange(e) {
        var money = this.formatAmount(e.target.value);
        this.setState({
            rentAmount: money
        });
    }

    onTermLengthChange(e) {
        var expirationDate = this.state.effectiveDate;
        const termLength = e.target.value;
        if(expirationDate != '') {
            expirationDate = moment.utc(expirationDate).local().add(termLength, 'month').format("Y-MM-DD");
        }

        this.setState({
            termLength: termLength,
            expirationDate: expirationDate
        });
    }

    render(){
        const termOptions = this.buildTermsSelect();
        const tenantId = this.state.tenant_id;
        const rentAmount = this.state.rentAmount;
        const termLength = this.state.termLength;
        var totalMonth = 0;
        if ((rentAmount > 0 || rentAmount != "0") && (termLength > 0 || termLength != "0")) {
            totalMonth = rentAmount.replace(',', '');
            totalMonth = parseFloat(totalMonth) / parseInt(termLength);

            totalMonth = totalMonth.toFixed(2);

            totalMonth = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(totalMonth)
            if (isNaN(totalMonth.replace(',', ''))) {
                totalMonth = 0;
            }
        }
        return (
            <div>
                <div class="col-md-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Setup a Payment Plan</h4>
                            <p class="category">Payment plans will bypass a tenants current lease term.</p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="assignee">Which tenant do you want to create a payment plan for?</label>
                                            <div class="clearfix"></div>
                                            <TenantsSelect title="" columnSize={4} sortId={tenantId} onChange={this.sortTenantSelect.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="assignee">What is the total amount to be paid over a period?</label>
                                            <input type="text" value={rentAmount} onChange={this.onRentChange.bind(this)} class="form-control" placeholder="$10,000"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>How many months should this payment plan be split out?</label>
                                            <select class="form-control" value={termLength} onChange={this.onTermLengthChange.bind(this)}>
                                                <option>Select a term length</option>
                                                { termOptions }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Total charge per month</label>
                                            <input type="text" disabled value={"$" + totalMonth} class="form-control" placeholder="$10,000"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="content">
                                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.startPaymentPlan.bind(this)}>
                                        Start Payment Plan
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Tenants/PaymentPlans/SetupPaymentPlan.jsx